var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.navList),function(item){return _c('el-breadcrumb-item',{attrs:{"to":item.to ? {path: item.to} : null}},[_vm._v(_vm._s(item.name))])}),1),_vm._t("default"),_c('div',{staticClass:"clear"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }